import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { NavLink, useParams } from "react-router-dom";
import { AppDispatch } from "../../redux/store";
import { handleBreadCrumb } from "../../redux/breadcrumb";
import { getCurrentUserData } from "../../common/utils/Functions";

// * Logic to render nav-links on the basis of role
export const HandleNavItems = ({ item, role }: any) => {
  const dispatch = useDispatch<AppDispatch>();
  const { uuid } = useParams();
  const data = getCurrentUserData(uuid as string);
  const { propertiesCount } = useSelector((store: RootState) => store.userData);
  const handleBreadCrumbValue = (label: string) => {
    dispatch(
      handleBreadCrumb({
        label,
      })
    );
  };

  //* check if nav-link role matches current login role
  if (item?.role === role) {
    // Hide specific items when organization has 0 properties (no extra API)
    const stored = localStorage.getItem('properties_count');
    const resolvedCount = typeof propertiesCount === 'number' ? propertiesCount : Number(stored ?? '0');
    const hasProperties = resolvedCount > 0;
    const isOrgRole = role === 2;
    const isManagedSection = item?.title === 'Manage Properties' || item?.title === 'Manager Accounts';
    if (isOrgRole && isManagedSection && !hasProperties) return <></>;
    // Hide "Payout Settings" and "Customize" for Property Managers (role 3)
    if (
      data?.role_id === 3 &&
      (item?.title === 'Payout Settings' || item?.title === 'Customize')
    )
      return <></>;
    const totalTips = Number(localStorage.getItem('total_tips') ?? '0');
    if (isOrgRole && item?.title === 'Dashboard' && totalTips === 0 && !hasProperties) return <></>;
    return (
      <NavLink
        to={data?.admin_uuid ? "/" + uuid + item?.link : item?.link}
        onClick={() => handleBreadCrumbValue(item?.title)}
      >
        <li>
          {item?.icon}
          {item?.title}
        </li>
      </NavLink>
    );
  } else return <></>;
};
